/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Meta_ErrorInputs */

const es_chat_meta_error = /** @type {(inputs: Chat_Meta_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocurrió un error al procesar tu mensaje`)
};

const en_chat_meta_error = /** @type {(inputs: Chat_Meta_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An error occurred while processing your message`)
};

/**
* | output |
* | --- |
* | "An error occurred while processing your message" |
*
* @param {Chat_Meta_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_meta_error = /** @type {((inputs?: Chat_Meta_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Meta_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_meta_error(inputs)
	return en_chat_meta_error(inputs)
});
export { chat_meta_error as "chat.meta.error" }